import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AlertController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { DictionaryService } from 'src/app/dictionary/dictionary.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { GuestReport } from '../guest-report.model';
import { GuestReportService } from '../guest-report.service';
import { TranslateService } from '@ngx-translate/core';
import { globalHelper } from 'src/app/_helpers/global';
import { PopoverButton } from 'src/app/app/_component/popover/popover.model';

@Component({
  selector: 'app-guest-report-view',
  templateUrl: './guest-report-view.component.html',
  styleUrls: [
    './guest-report-view.component.scss',
    '../../../../_styles/ion-grid-content-table.scss',
  ],
})
export class GuestReportViewComponent implements OnInit {
  constructor(
    public dictionaryServ: DictionaryService,
    public p: ThisPlatform,
    public alertController: AlertController,
    public translateService: TranslateService,
    public modalCtrl: ModalController,
    public popoverController: PopoverController,
    public guestReportServ: GuestReportService,
    public translate: TranslateService
  ) {}

  mobile = false;

  @Input()
  row: GuestReport;

  @Input()
  customData: string;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  buttonList: PopoverButton[] = [
    {
      name: 'Szczegóły',
      icon: 'information-circle',
      eventType: 'info',
    },
  ];

  ngOnInit() {}

  async moreDetailsPopover(ev: any) {
    this.guestReportServ.guestReport = this.row;

    let popover = await globalHelper.Popover(
      this.popoverController,
      ev,
      this.buttonList,
      'user-assignment-view-share__popover'
    );
  }
}
